module.exports = __webpack_public_path__ + "67859f574657c147ba325f15830fb89c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/toolbar/trash.svg
// module id = 170
// module chunks = 0